module.exports = __webpack_public_path__ + "media/connectivity-slide1.76b61328.mp4";